'use client';
import { useState, useCallback } from 'react';
import { useInterval } from '../useInterval/useInterval.js';

var useIntervalControls = function(callbackFn, interval, options) {
    if (options === void 0) options = {
        autoStart: true
    };
    var autoStart = options.autoStart;
    var _useState = useState(autoStart), active = _useState[0], setActive = _useState[1];
    var start = useCallback(function() {
        return setActive(true);
    }, []);
    var stop = useCallback(function() {
        return setActive(false);
    }, []);
    useInterval(callbackFn, active ? interval : null);
    return {
        start: start,
        stop: stop,
        active: active
    };
};

export { useIntervalControls };
